import React from "react";
import PropTypes from "prop-types";

import { Column, Field, Control, Label, Input } from "rbx";

function CustomerFilters({ filters, onChange }) {
  const handleChange = e => {
    const value =
      e.target.type === "checkbox" ? e.target.checked : e.target.value;
    const updates = { ...filters };
    if (e.target.name.includes("RecIdRef")) {
      updates[e.target.name] = parseInt(value);
    } else {
      updates[e.target.name] = value;
    }
    onChange(
      Object.keys(updates).reduce((a, c) => {
        if (String(updates[c]).length) {
          a[c] = updates[c];
        }
        return a;
      }, {})
    );
  };

  return (
    <React.Fragment>
      <Column.Group>
        <Column size={1}>
          <Field>
            <Control expanded>
              <Label>Customer #</Label>
              <Input
                autocomplete="new"
                name="CustomerNo_contains"
                type="text"
                value={filters.CustomerNo_contains}
                onChange={handleChange}
              />
            </Control>
          </Field>
        </Column>

        <Column size={3}>
          <Field>
            <Control>
              <Label>Customer Name</Label>
              <Input
                autocomplete="new"
                name="Name_contains"
                type="text"
                value={filters.Name_contains}
                onChange={handleChange}
              />
            </Control>
          </Field>
        </Column>
        {/* <Column>
          <Field kind="group">
            <Control expanded>
              <Label>City</Label>
              <Input
                autocomplete="new"
                type="text"
                name="City_contains"
                value={filters.City_contains}
                onChange={handleChange}
              />
            </Control>
            <Control>
              <Label>State</Label>
              <StateSelect
                name="State"
                value={filters.State}
                onChange={handleChange}
              />
            </Control>
          </Field>
        </Column>
        <Column>
          <Field kind="group">
            <Control>
              <Label>Bill To</Label>
              <BooleanInput
                name="BillToCust"
                value={filters.BillToCust}
                onChange={handleChange}
              />
            </Control>
            <Control>
              <Label>Order</Label>
              <BooleanInput
                name="OrderCust"
                value={filters.OrderCust}
                onChange={handleChange}
              />
            </Control>
            <Control>
              <Label>Active</Label>
              <BooleanInput
                name="Active"
                value={filters.Active}
                onChange={handleChange}
              />
            </Control>
          </Field>
        </Column> */}
      </Column.Group>
    </React.Fragment>
  );
}
CustomerFilters.propTypes = {
  filters: PropTypes.object,
  onChange: PropTypes.func
};
CustomerFilters.defaultProps = {
  filters: {}
};
export default CustomerFilters;
